import {atom} from "jotai";
import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {User, UserPreferences} from "../types/domain/user";
import {getUserById, getUserNotificationsStats} from "../services/userService";
import {authenticationAtom} from "./authenticationStore";
import {impersonationAtom} from "./impersonationStore";
import {DEFAULT_USER_PREFERENCES} from "../utils/userUtils";
import {UserNotificationsStats} from "../types/domain/userNotificationsStats";
import {MRT_Localization} from "material-react-table";
import {MRT_Localization_EN} from "material-react-table/locales/en";

/**
 * Current user properties
 */
export const authenticatedUserAtom = atomWithRefresh<Promise<User>>(async (get): Promise<User> => {
    const auth = await get(authenticationAtom);
    const impersonation = get(impersonationAtom);
    const userId = impersonation ?? auth.userId;

    return await getUserById(userId);
});

export const authenticatedUserLoadable = loadable(authenticatedUserAtom);

/**
 * Current user preferences
 */
export const authenticatedUserPreferencesAtom = atom<Promise<UserPreferences>>(async (get) => {
    const authenticatedUser = await get(authenticatedUserAtom);
    return {
        ...DEFAULT_USER_PREFERENCES,
        ...authenticatedUser.preferences,
    } as UserPreferences;
});

export const authenticatedUserPreferencesLoadable = loadable(authenticatedUserPreferencesAtom);

export const authenticatedUserNotificationsStatsAtom = atomWithRefresh<Promise<UserNotificationsStats>>(
    async (get): Promise<UserNotificationsStats> => {
        const auth = await get(authenticationAtom);
        const impersonation = get(impersonationAtom);
        const userId = impersonation ?? auth.userId;

        return await getUserNotificationsStats(userId);
    },
);

export const authenticatedUserNotificationsStatsLoadable = loadable(authenticatedUserNotificationsStatsAtom);

export const authenticatedUserTableLocaleAtom = atom<MRT_Localization>(MRT_Localization_EN);
